export default __webpack_public_path__ + "static/media/banner-main-text-img.81261a04.png";